import React from "react";
import PropTypes from "prop-types";
import NavIcon from "./NavIcon";
import styles from "./NavIcons.module.css";
import { getNavIcon, getNavPartProps } from "../navigationBarBrandRefreshClasses";

const legacyProfileIcon = require("./imgs/Profile.svg");
const brandRefreshProfileIcon = require("./imgs/brand-refresh-Profile.svg");

const ProfileIcon = ({ isLoggedIn, userFirstName, userLastName, onClick }) => {
  const profileIcon = getNavIcon(legacyProfileIcon, brandRefreshProfileIcon);

  const getInitials = () => {
    if (!userFirstName || !userLastName) return "";
    const first = userFirstName.charAt(0).toUpperCase();
    const last = userLastName.charAt(0).toUpperCase();
    return `${first}${last}`;
  };

  return (
    <NavIcon onClick={onClick} ariaLabel="User profile">
      {isLoggedIn ? (
        <span
          className={styles.profileIcon}
          data-part={getNavPartProps("profile-icon")}
        >
          {getInitials()}
        </span>
      ) : (
        <img
          src={profileIcon}
          alt=""
          className={styles.profileIcon}
          data-part={getNavPartProps("profile-icon")}
        />
      )}
    </NavIcon>
  );
};

ProfileIcon.propTypes = {
  isLoggedIn: PropTypes.bool,
  userFirstName: PropTypes.string,
  userLastName: PropTypes.string,
  onClick: PropTypes.func
};

ProfileIcon.defaultProps = {
  isLoggedIn: false,
  userFirstName: "",
  userLastName: "",
  onClick: undefined
};

export default ProfileIcon;
